/**
 * @file The refusal of one column of an answered named query, or null when
 * the column is answered. Consumers: the Overview figure, Projects, Pipeline,
 * Orders and Invoicing models. A refused column is null in every row, so a
 * model shows this refusal in its place rather than reading the null as zero.
 */
import type { Snapshot } from 'valtio';

import type { NamedQueryRefusedColumn, NamedQueryResult } from '#types';

export const analyticsRefusedColumn = (
  result: Snapshot<NamedQueryResult>,
  column: string,
): NamedQueryRefusedColumn | null =>
  result.refusedColumns.find((refused) => refused.column === column) ?? null;
